var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubber20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_84497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5116 6.57554L13.1136 2.17769C12.8771 1.94112 12.4935 1.94107 12.2569 2.17769L5.42578 9.00875L10.6804 14.2633L17.5116 7.43233C17.7482 7.1958 17.7482 6.8122 17.5116 6.57554Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34063 10.0938L2.48997 11.9444C2.25334 12.1809 2.25334 12.5645 2.48997 12.801L6.88792 17.1991C7.1245 17.4356 7.5081 17.4355 7.74468 17.1991L9.5953 15.3484L4.34063 10.0938Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67383 17.9999H17.1909V16.7532H10.126L8.67383 17.9999Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_84497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9998,
    fill: "white",
    transform: "translate(2 2.00024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubber20);
export default __webpack_public_path__ + "static/media/Rubber20.79b4b07fc789a3fd687413b10edd4f26.svg";
export { ForwardRef as ReactComponent };